import styled from 'styled-components';
import colors from '../../../assets/styles/colors';
import ReactTooltip from 'react-tooltip';

export const ClientDataSearchColumn = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-top: 20px;
`;

export const ClientDataHead = styled.div`
  cursor: pointer;
  width: 100%;
  height: 45px;
  background: #DDDDDD;
  border-radius: 9px 0px 9px 0px;
  margin-top: 35px;
  display: flex; 
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 2px 0px #00DB8E;
`;


export const ClientDataHeadLabel = styled.p`
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.03em;
  color: #06005A;
  margin-left: 15px;
`;


export const ClientDataSearchError = styled.div`
    display: ${prop => prop.visible ? 'inline' : 'none'};
    color:${colors.bgDanger};
    font-size: 12px;
    line-height: 14px;
    margin: 5px 8px;
    transition: ease-in-out .2s;
`;

export const ClientDataButtoCalculateButton = styled.button`
  align-items: center;
  padding: 8px 32px;
  background: ${colors.bgTertiary};
  border: 1px solid ${colors.bgTertiaryLight};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.03em;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  transition: ease-in-out .2s;
  min-width: 158px;

  &:hover {
    background: ${colors.bgTertiaryHover};
    border: 1px solid ${colors.bgTertiaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const ClientDataButtoCalculate = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${prop => prop.align ? 'space-between' : 'flex-end'};
  margin-top: 29px;
  margin-bottom: 23px;
`;

export const ClientDataAddButton = styled.span`
  color: ${colors.bgSecondary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
  text-decoration: underline;
`;

export const ClientDataTotal = styled.div`
  margin-top: 8px;
  border-radius: 8px;
  padding: 16px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const ClientDataMontoTotal = styled.div`
  margin-top: 8px;
  padding: 16px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(250, 202, 22, 0.08);
  border-radius: 9px;
`;

export const ClientDataTotalTitle = styled.span`
font-family: 'Montserrat';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 150%;
/* or 24px */

text-align: center;
text-transform: uppercase;

color: #484848;
`;

export const ClientDataTotalPrice = styled.span`
  margin-top: 6px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: black;
`;

export const ClientDataTotalData = styled.span`

font-family: 'Montserrat';
font-style: normal;
font-weight: 700;
font-size: 36px;
line-height: 44px;
text-align: center;

color: #484848;
`;

export const ClientDataTotalDataMin = styled.span`

font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 16px;
text-align: center;
text-decoration-line: underline;

color: #214297;
`;



export const ClientDataTotalDataMinBlack = styled.span`

font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 16px;
display: flex;
align-items: center;
text-align: center;

color: #484848;
`;

export const TooltipTitle = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
`;

export const TooltipContent = styled.div`
font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.03em;
`;

export const Tooltip = styled(ReactTooltip).attrs({
  className: "custom-tooltip",
})`
  &.custom-tooltip {
    width: 300px !important;
    padding: 13px !important;
    font-family: Montserrat !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 22px !important;
    letter-spacing: 0.03em !important;
    opacity: 1 !important;
    background-color: rgb(187, 215, 212);
  }
`;

export const InfoCircleImage = styled.img`
  margin-bottom:-3px;
  margin-left: 3px;
`;  

export const StepFourColumn = styled.div`
  background: ${colors.white};
  border: 2px solid ${colors.grayLight};
border-radius: 8px;
padding: 20px;
`;

export const StepFourDisplayValues = styled.div`
`;

export const StepFourDisplayResultLabel = styled.h6`
  color: ${colors.bgPrimary};
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  margin-bottom: 30px;
`;

export const FinancesDataCreditLine = styled.div`
  margin-top: 40px;
`;

export const FinancesDataCreditLineTitle = styled.h6`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
`;

export const FinancesDataCreditCheckboxContainer = styled.div`
  display: flex;
  align-self: flex-end;
  margin-right: 20px;  
  flex-direction: column;
  border: 1px solid ${colors.bgPrimary}; 
  border-radius: 10px;
  padding: 15px;
`;  

export const FinancesDataCreditCheckboxContainerLine = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  & > div {
    margin-top: 30px;
  }
`;

export const FinancesDataCreditCheckboxContainerText = styled.div`  
  color: ${colors.textPrimary};
  margin-top: 15px;
`;

export const FinancesDataCreditCheckboxContainerTitle = styled.div`
  font-weight: bold;
`;

export const FinancesDataCreditCheckboxContainerSaldo = styled.div`
  box-shadow: 0px 8px 25px ${colors.shadow};
  border-radius: 8px;
  padding: 17px;
  align-items: center;
  display: flex;
`;

export const FinancesDataAddButton = styled.span`
  color: ${colors.bgSecondary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
  text-decoration: underline;
`;

export const FinancesDataFieldContent = styled.div`
  margin-top: 30px;
`;

export const FinancesDataFieldTitle = styled.span`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
  margin-top: 28px;
  display: block;
`;

export const FinancesDataFieldInputTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FinancesDataFieldTitleValorLabel = styled.label`
  color: ${colors.textPrimary};
  opacity: 0.9;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
`;

export const FinancesDataFieldTitleValorDeleteItem = styled.span`
  cursor: pointer;
  color: ${colors.bgDanger};
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;

export const FinancesDataFieldContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
`;

export const FinancesDataTotalFieldsCredits = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.textExGrayLight};
  border-radius: 8px;
  padding: 20px;
  margin: 40px auto 60px auto;
`;

export const FinancesDataTotalFieldsCreditsLabel = styled.span`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.03em;
`;

export const FinancesDataTotalFieldsCreditsValue = styled.span`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  margin-left: 10px;
`;

export const FinancesDataNoCredit = styled.span`
  color: ${colors.bgDanger};
  display: block;
  margin-top: 5px;
  font-size: 16px;
`;

export const SaldoTotalRecoger = styled.div`
  margin-top: 8px;
  background: ${colors.bgFourthLight};
  border-radius: 8px;
  padding: 0px 5px 30px 0px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  & > div {
    margin-top: 30px;
  }
`;

export const SaldoTotalRecogerContainer = styled.div`
  display: flex;
  align-self: flex-end;
  margin-right: 20px;  
  margin-left: 20px;
  flex-direction: column;
  margin-top: 6px;
  font-weight: 540;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.white};
`;  